import React from "react"
import { Banner } from "@shopify/polaris"
import { useTranslation } from "react-i18next"

const LegacyMethodologyBanner = () => {
  const { t } = useTranslation()

  return (
    <Banner status="warning">
      {t("analyze:websites.legacy_methodology_banner")}
    </Banner>
  )
}

export default LegacyMethodologyBanner
